/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_Q3Inputs */

const en_to_xml_faq_q3 = /** @type {(inputs: To_Xml_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What about JSON keys with special characters?`)
};

const ko_to_xml_faq_q3 = /** @type {(inputs: To_Xml_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`특수 문자가 포함된 JSON 키는 어떻게 처리되나요?`)
};

const ja_to_xml_faq_q3 = /** @type {(inputs: To_Xml_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特殊文字を含むJSONキーはどうなりますか？`)
};

/**
* | output |
* | --- |
* | "What about JSON keys with special characters?" |
*
* @param {To_Xml_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_q3 = /** @type {((inputs?: To_Xml_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_q3(inputs)
	if (locale === "ko") return ko_to_xml_faq_q3(inputs)
	return ja_to_xml_faq_q3(inputs)
});